export const createInputFieldsSlice = (set) => ({
  email: '',
  password: '',
  setEmail: (email) => set({ email }),
  setPassword: (password) => set({ password }),
  resetInputFields: () => set({ email: '', password: '' })
});
